// extracted by mini-css-extract-plugin
module.exports = {"typeText":"persTypesPopup__typeText__1cnzm","typeIconWrap":"persTypesPopup__typeIconWrap__3o16Y","bulletIcon":"persTypesPopup__bulletIcon__1-tY6"};